export default "__VITE_ASSET__hlS5wEJ9__"